<template>
  <div name="demo-searchbox-box-type">
    <hrms-search-box	 :receivedStore="receivedStore"
            			 :nowLang="nowLang"
            			 searchBoxAlias="demo-searchbox-box-type" />
  </div>
</template>

<script>
export default {
  name: 'demo-searchbox-box-type',
  data () {
    return {
      nowLang: 'en'
    }
  },
  methods: {
    receivedStore (params) {
      console.log(params)
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoSearchboxBoxType.vue?e26ec214